module.exports = __webpack_public_path__ + "img/portraits_22_V.23186544.webp";